import { HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { EnvironmentConfig, IConfiguration } from '../../../client-config/bma-env-config';
import { CustomHttpClientService } from '../../custom-http-client.service';
import { ITimeHydraModel } from './timeModel';

@Injectable({ providedIn: 'root' })
export class TimeSyncService {
    private timeDelta: number;
    private customerIp: string;
    private readonly environment: IConfiguration = inject(EnvironmentConfig).configuration;
    private customHttpClientService = inject(CustomHttpClientService);
    constructor() {
        (this.getUserSessionTime(true, false) as Observable<ITimeHydraModel>).subscribe((cmsData: ITimeHydraModel) => {
            this.timeDelta = cmsData.timestamp - Date.now();
            this.customerIp = cmsData['x-forward-for'];
        });
    }

    getUserSessionTime(hasTime?: boolean, isPromise?: boolean): Observable<ITimeHydraModel> | Promise<ITimeHydraModel> | any {
        const observable = this.customHttpClientService.httpClient
            .get<ITimeHydraModel>(`${this.environment.TIME_ENDPOINT}/v1/session${hasTime && '?time=true'}`, {
                observe: 'response',
            })
            .pipe(
                map((data: HttpResponse<ITimeHydraModel>) => data.body ?? {}),
                catchError((error) => {
                    console.error('Error fetching session data:', error);
                    return throwError(error); // handle error appropriately
                }),
            );

        return isPromise ? observable.toPromise() : observable;
    }

    getTimeDelta(): number {
        return this.timeDelta ? this.timeDelta : 0;
    }

    get ip(): string {
        return this.customerIp || '91.232.241.59';
    }
    set ip(value: string) {}
}
